"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hasOwn = Object.prototype.hasOwnProperty;
function isFunction(v) {
    return typeof v === 'function';
}
exports.isFunction = isFunction;
function defaultToNull(v) {
    return v === void 0 ? null : v;
}
exports.defaultToNull = defaultToNull;
function toBoolean(v) {
    return Boolean(isFunction(v) ? v() : v);
}
exports.toBoolean = toBoolean;
function toElement(c, data) {
    if (data === void 0) { data = void 0; }
    return defaultToNull(isFunction(c) ? c(data) : c);
}
exports.toElement = toElement;
function is(x, y) {
    if (x === y) {
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    else {
        return x !== x && y !== y;
    }
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null ||
        typeof objB !== 'object' || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}
exports.shallowEqual = shallowEqual;
//# sourceMappingURL=util.js.map